<template>
  <div class="article">
    <sHeader :activeIndex="'5'"/>

    <div class="article-content" v-if="article_info">
      <div v-if="article_info.audio">
        <AudioPlayer :data="article_info"/>
      </div>

      <div v-if="article_info.type == 'html'">
        <div class='html-content' v-html="article_info.content"></div>
      </div>

      <div v-else>
        <div class='special'>
          <img :src="article_info.image" >
        </div>
      </div>

    </div>

    <div class="promotion" v-if="article_info && article_info.promotion">
      <img :src="article_info.promotion" >
    </div>

    <div id="relates" v-if="relates">
      <!-- <h2>下一集</h2> -->
      <div class="videos" v-for="(item, index) in relates" :key="index">
        <VideoItem :data="item" />
      </div>
    </div>
  </div>
</template>

<script>
import sHeader from '@/components/templates/sHeader'
import AudioPlayer from '@/components/templates/AudioPlayer'
import VideoItem from '@/components/templates/VideoItem'

export default {
  components: {
    sHeader,
    AudioPlayer,
    VideoItem
  },
  mounted () {
    this.article_id = this.$route.params.id
    // console.log('id: ', this.article_id)
    if (this.article_id > 0) {
      this.$ajax.get('interface.php?media=1&type=article&id=' + this.article_id)
        .then((res) => {
          this.article_info = res.data.info
          this.relates = res.data.info.relates
          console.log('article: ', this.article_info)
          document.title = this.article_info.page_title
        })
    }
  },
  methods: {
  },
  data () {
    return {
      article_id: 0,
      article_info: null,
      relates: null
    }
  }

}
</script>

<style scoped>
.special img {
  width: 100%;
}
.article-content {
  margin: 88px 0 20px 0;
}
.promotion {
  margin-bottom: 10px;
  text-align: center;
}
</style>
<style>
.html-content img {
  width: 100%;
  /* max-width: 100%; */
}
.html-content iframe {
  width: 100%;
  height: 360px;
}
video {
  width: 100%;
  margin-left: 20px;
}
.promotion img {
  width: 100%;
  max-width: 290px;
}
</style>



// WEBPACK FOOTER //
// src/components/Article.vue